import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { StyledAnchor } from '../../utils/styles'

const StyledImg = styled.img`
  max-height: 30px;
`

const StyledSpan = styled.span`
  margin-left: 10px;
  @media (max-width: 515px) {
    display: none;
  }
`

const BrandWrapper = styled.div`
  margin-left: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`

export const Brand = () => {
  return (
    <BrandWrapper>
      <Link href="/explore/element/f794daa1e63029828ec58248549815d2">
        <StyledAnchor>
          <StyledImg src="/static/logo.png" />
          <StyledSpan>DATA PORTAL</StyledSpan>
        </StyledAnchor>
      </Link>
    </BrandWrapper>
  )
}
